<script>
import { CONTEST_TYPE_INDIVIDUAL   } from '../model/contest.js';
import { CONTEST_TYPE_CHAMPS       } from '../model/contest.js';
import { CONTEST_TYPE_CLUBS        } from '../model/contest.js';
import { CONTEST_TYPE_TEA          } from '../model/contest.js';
import { CONTEST_TYPE_BUGZ         } from '../model/contest.js';
import { CONTEST_TYPE_GVNT         } from '../model/contest.js';
import { CONTEST_TYPE_RAINBOW_RUSH } from '../model/contest.js';

import TmntIndividualStat from './TmntIndividualStat.vue';
import TmntChampsStat     from './TmntChampsStat.vue';
import TmntClubsStat      from './TmntClubsStat.vue';
import TmntChestStat      from './TmntChestStat.vue';
import TmntGvntStat       from './TmntGvntStat.vue';
import ContestRainbowStat from './ContestRainbowStat.vue';

export default {
  name: 'ContestConcreteStat',

  props: {
    tmnt: {
      type: Object,
      required: true,
    },
  },

  render(createElement) {
    const componentType = getComponentType(this.tmnt.type);
    const data = {
      props: {
        stat: this.tmnt.stat,
      },
    };
    return createElement(componentType, data);
  },
};

/**
 * @param {number} contestType
 * @returns {Object}
 */
function getComponentType(contestType) {
  switch(contestType) {
    case CONTEST_TYPE_INDIVIDUAL:
      return TmntIndividualStat;
    case CONTEST_TYPE_CHAMPS:
      return TmntChampsStat;
    case CONTEST_TYPE_CLUBS:
      return TmntClubsStat;
    case CONTEST_TYPE_TEA:
      return TmntChestStat;
    case CONTEST_TYPE_BUGZ:
      return TmntIndividualStat;
    case CONTEST_TYPE_GVNT:
      return TmntGvntStat;
    case CONTEST_TYPE_RAINBOW_RUSH:
      return ContestRainbowStat;
  }
  return null;
}
</script>
